interface SkeletonCardProps {
  count?: number;
}

export default function SkeletonCard({ count = 1 }: SkeletonCardProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
        >
          <div className="skeleton-shimmer relative aspect-video w-full overflow-hidden bg-background-200" />
          <div className="flex flex-col gap-2 p-4">
            <div className="skeleton-shimmer relative h-4 w-4/5 overflow-hidden rounded bg-background-200" />
            <div className="skeleton-shimmer relative h-4 w-3/5 overflow-hidden rounded bg-background-200" />
            <div className="skeleton-shimmer relative mt-1 h-3 w-2/5 overflow-hidden rounded bg-background-200" />
          </div>
        </div>
      ))}
    </>
  );
}